module.exports = __webpack_public_path__ + "static/assets/a3a7803af853a484bff84f43d5a89114.png";